import { useLocalStorage } from '@uidotdev/usehooks';
import { FC } from 'react';

import WaveUIProgressDialog from '@/shared/components/dialogs/WaveUIProgressDialog';
import WaveUINotificationBar from '@/shared/components/utilities/WaveUINotificationBar';
import useModalDialog from '@/shared/hooks/useModalDialog';
import useNotificationBar from '@/shared/hooks/useNotificationBar';
import useProgressDialog from '@/shared/hooks/useProgressDialog';
import DialogName from '@/shared/types/dialogName.enum';
import { InventoryGetModel } from '@/shared/types/inventory.type';

import UpdateInventoryItemsDialog from '../components/UpdateInventoryItemsDialog';
import useFetchInventoryMetadata from '../hooks/useFetchInventoryMetadata';
import InventoryTable_v2 from './components/InventoryTable_v2/InventoryTable_v2';
import useInventoryOperations from './components/InventoryTable_v2/hooks/useInventoryOperations';
import Title from './components/Title';

const InventoryMain: FC = () => {
  const { dialog, onUpdateDialogState } = useModalDialog<unknown, DialogName>();
  const { progressDialog, onUpdateProgressDialog } = useProgressDialog();
  const { notificationBar, onUpdateNotificationBar } = useNotificationBar();

  const { onUpdateInventoryItems } = useInventoryOperations({
    onUpdateDialogState,
    onUpdateNotificationBar,
    onUpdateProgressDialog,
  });

  const { metadata } = useFetchInventoryMetadata();

  const [stashedMetadata, setStashedMetadata] = useLocalStorage<Record<
    string,
    unknown
  > | null>('stashedInventoryMetadata-main', null);

  return (
    <div>
      <Title />

      <InventoryTable_v2
        stashedMetadata={stashedMetadata}
        onUpdateInventoryItems={(selectedRows) => {
          onUpdateDialogState(DialogName.UpdateInventoryItems, {
            open: true,
            errors: [],
            data: selectedRows,
          });
        }}
      />

      {dialog?.updateInventoryItems?.open && metadata && (
        <UpdateInventoryItemsDialog
          metadata={metadata}
          stashedMetadata={stashedMetadata}
          errors={dialog?.updateInventoryItems?.errors}
          onClose={() => {
            onUpdateDialogState(DialogName.UpdateInventoryItems, {
              open: false,
              errors: [],
            });
          }}
          onStash={setStashedMetadata}
          proceed={(metadataDetails) => {
            const { data } = dialog?.updateInventoryItems as {
              data: InventoryGetModel[];
            };
            void onUpdateInventoryItems(
              stashedMetadata || metadataDetails,
              data,
            );
            setStashedMetadata(null);
          }}
        />
      )}

      <WaveUINotificationBar
        message={notificationBar.message}
        severity={notificationBar.severity}
        open={notificationBar.open}
        close={() => onUpdateNotificationBar({ open: false })}
      />

      <WaveUIProgressDialog
        title={progressDialog?.title}
        progress={progressDialog?.progress || 0}
        open={progressDialog?.open || false}
      />
    </div>
  );
};

export default InventoryMain;
